"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmsClient = void 0;
const http_client_1 = require("@finbackoffice/http-client");
class CmsClient extends http_client_1.HTTPClient {
    createMedia(request) {
        const body = new FormData();
        body.append("path", request.path);
        body.append("file", request.body, request.filename);
        return this.send({
            method: "POST",
            path: "media",
            body: body,
        });
    }
    findMedia(id) {
        return this.send({
            method: "GET",
            path: "media/:id",
            params: {
                id: id.toString(),
            },
        });
    }
    createPopup(request) {
        return this.send({
            method: "POST",
            path: "popup",
            body: request,
        });
    }
    updatePopup(id, request) {
        return this.send({
            method: "PUT",
            path: "popup/:id",
            params: {
                id: id.toString(),
            },
            body: request,
        });
    }
    findPopup(id) {
        return this.send({
            method: "GET",
            path: "popup/:id",
            params: {
                id: id.toString(),
            },
        });
    }
    deletePopup(id) {
        return this.send({
            method: "DELETE",
            path: "popup/:id",
            params: {
                id: id.toString(),
            },
        });
    }
    queryPopup(request) {
        return this.send({
            method: "PUT",
            path: "popup",
            body: request,
        });
    }
    findActivePopups(request) {
        return this.send({
            method: "PUT",
            path: "popup/active",
            body: request,
        });
    }
    createBanner(request) {
        return this.send({
            method: "POST",
            path: "banner",
            body: request,
        });
    }
    updateBanner(id, request) {
        return this.send({
            method: "PUT",
            path: "banner/:id",
            params: {
                id: id.toString(),
            },
            body: request,
        });
    }
    findBanner(id) {
        return this.send({
            method: "GET",
            path: "banner/:id",
            params: {
                id: id.toString(),
            },
        });
    }
    deleteBanner(id) {
        return this.send({
            method: "DELETE",
            path: "banner/:id",
            params: {
                id: id.toString(),
            },
        });
    }
    deleteBannerTranslation(id, language) {
        return this.send({
            method: "DELETE",
            path: "banner/:id/translation/:language",
            params: {
                id: id.toString(),
                language,
            },
        });
    }
    queryBanner(request) {
        return this.send({
            method: "PUT",
            path: "banner",
            body: request,
        });
    }
    findActiveBanners(request) {
        return this.send({
            method: "PUT",
            path: "banner/active",
            body: request,
        });
    }
    createUserInterface(request) {
        return this.send({
            method: "POST",
            path: "user-interface",
            body: request,
        });
    }
    updateUserInterface(id, request) {
        return this.send({
            method: "PUT",
            path: "user-interface/:id",
            params: {
                id: id.toString(),
            },
            body: request,
        });
    }
    findUserInterface(id) {
        return this.send({
            method: "GET",
            path: "user-interface/:id",
            params: {
                id: id.toString(),
            },
        });
    }
    findUserInterfacesByKey(key, device_type) {
        return this.send({
            method: "GET",
            path: "user-interface/:device_type/:key",
            params: {
                device_type,
                key,
            },
        });
    }
    deleteUserInterface(id) {
        return this.send({
            method: "DELETE",
            path: "user-interface/:id",
            params: {
                id: id.toString(),
            },
        });
    }
    deleteUserInterfaceTranslation(id, language) {
        return this.send({
            method: "DELETE",
            path: "user-interface/:id/translation/:language",
            params: {
                id: id.toString(),
                language,
            },
        });
    }
    queryUserInterface(request) {
        return this.send({
            method: "PUT",
            path: "user-interface",
            body: request,
        });
    }
    searchUserInterfaceByContent(request) {
        return this.send({
            method: "PUT",
            path: "user-interface/search-by-content",
            body: request,
        });
    }
    getUserInterfaceTranslationsPublic(request) {
        return this.send({
            method: "PUT",
            path: "user-interface/translations/public",
            body: request,
        });
    }
    importUserInterfaces(request) {
        const body = new FormData();
        body.append("file", request.body);
        return this.send({
            method: "POST",
            path: "user-interface/import/:device_type",
            body: body,
            params: {
                device_type: request.device_type,
            },
        });
    }
    createNotification(request) {
        return this.send({
            method: "POST",
            path: "notification",
            body: request,
        });
    }
    updateNotification(id, request) {
        return this.send({
            method: "PUT",
            path: "notification/:id",
            params: {
                id: id.toString(),
            },
            body: request,
        });
    }
    findNotification(id) {
        return this.send({
            method: "GET",
            path: "notification/:id",
            params: {
                id: id.toString(),
            },
        });
    }
    queryNotification(request) {
        return this.send({
            method: "PUT",
            path: "notification",
            body: request,
        });
    }
    deleteNotification(id) {
        return this.send({
            method: "DELETE",
            path: "notification/:id",
            params: {
                id: id.toString(),
            },
        });
    }
    findActiveNotifications(request) {
        return this.send({
            method: "PUT",
            path: "notification/active",
            body: request,
        });
    }
    createReel(request) {
        return this.send({
            method: "POST",
            path: "reel",
            body: request,
        });
    }
    updateReel(id, request) {
        return this.send({
            method: "PUT",
            path: "reel/:id",
            params: {
                id: id.toString(),
            },
            body: request,
        });
    }
    findReel(id) {
        return this.send({
            method: "GET",
            path: "reel/:id",
            params: {
                id: id.toString(),
            },
        });
    }
    deleteReel(id) {
        return this.send({
            method: "DELETE",
            path: "reel/:id",
            params: {
                id: id.toString(),
            },
        });
    }
    deleteReelTranslation(id, language) {
        return this.send({
            method: "DELETE",
            path: "reel/:id/translation/:language",
            params: {
                id: id.toString(),
                language,
            },
        });
    }
    queryReel(request) {
        return this.send({
            method: "PUT",
            path: "reel",
            body: request,
        });
    }
    findActiveReels(request) {
        return this.send({
            method: "PUT",
            path: "reel/active",
            body: request,
        });
    }
    addReelLike(id, user_id) {
        return this.send({
            method: "POST",
            path: "reel/:id/like/:user_id",
            params: {
                id: id.toString(),
                user_id: user_id.toString(),
            },
        });
    }
}
exports.CmsClient = CmsClient;
//# sourceMappingURL=client.js.map